import { RouteView } from '@/layouts';

const carouselRouter = {
  path: '/carousel',
  name: 'Carousel',
  redirect: '/carousel/list',
  component: RouteView,
  meta: {
    title: '轮播管理',
    icon: 'iconshuffling-banner',
    roles: ['admin'],
  },
  hideChildrenInMenu: true,
  children: [
    {
      path: 'list',
      name: 'CarouselList',
      component: () => import('@/views/carousel/List'),
      meta: {
        title: '资讯列表',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'add',
      name: 'CarouselAdd',
      component: () => import('@/views/carousel/Add'),
      meta: {
        title: '添加资讯',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'editor',
      name: 'CarouselEditor',
      component: () => import('@/views/carousel/Editor'),
      meta: {
        title: '资讯编辑',
        roles: ['admin'],
        hidden: true,
      },
    },
    {
      path: 'detail',
      name: 'CarouselDetail',
      component: () => import('@/views/carousel/Detail'),
      meta: {
        title: '查看',
        roles: ['admin'],
        hidden: true,
      },
    },
  ],
};

export default carouselRouter;
